import { z } from 'zod';
import { bindUnvalidatableInputMaker } from '../util.make-unvalidatable-input.js';

const makeInput = bindUnvalidatableInputMaker();
const onImageReadonlyInput = makeInput({
  schema: z.object({
    type: z.literal("ReadOnly"),
    text: z.string().optional().default(""),
    placement: z.object({
      x: z.number(),
      y: z.number()
    }),
    style: z.object({
      align: z.enum(["Left", "Center", "Right"]).default("Center"),
      bold: z.boolean().default(false),
      italic: z.boolean().default(false)
    }).default({
      align: "Center",
      bold: false,
      italic: false
    })
  }),
  postprocessSchemaInput: ({
    text,
    style,
    placement
  }, context) => {
    return {
      id: `${context.taskId}-${context.index}`,
      nodeType: "on-image-readonly",
      placement,
      text,
      style
    };
  }
});

export { onImageReadonlyInput };
//# sourceMappingURL=input.readonly.js.map
